<!-- Listado de Vehículos -->
<app-modal-vehicle-edit *ngIf="showModal" [selectedVehicle]="selectedVehicle" (close)="showModal = false"> </app-modal-vehicle-edit>

<div class="mb-5 animate__animated animate__fadeInDown">
    <div class="panel space-y-5">
        <h5 class="mt-20 lg:mt-0 md:mt-10 text-3xl font-semibold text-center text-black dark:text-white">
            <!-- {{ 'VEHICLES.PLATE' | translate }} -->
            ¡No te pierdas ninguna cita! <br />
            Consulta tu calendario y mantén tu vehículo siempre al día 📅
        </h5>
        <div class="flex justify-center">
            <button type="button" class="btn btn-sm bg-primary w-44 text-2xl h-14 border border-white" (click)="goCalendar()">Calendario</button>
        </div>
    </div>
</div>
<div>
    <app-add-vehicle (vehicleCreated)="handleVehicleCreated($event)"></app-add-vehicle>
</div>

<div *ngIf="vehicles.length > 0" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-4">
  <div *ngFor="let vehicle of vehicles" class="card-with-stars bg-white dark:bg-gray-800 p-4 rounded-lg shadow-lg">
    <div class="container mt-5">
      <div class="license-plate border-4 border-black dark:border-white relative">
        <div class="plate-header font-bold"><h1>PITZON</h1></div>
        <div class="plate-number font-bold">{{ vehicle.plate }}</div>
        <div class="plate-city font-bold">{{ vehicle.city.name }}</div>
      </div>
    </div>

    <div class="flex justify-center">
      <img class="w-44 h-auto my-2" alt="Vehículo" [src]="vehicle.icon" />
    </div>

    <div class="text-center mt-4">
      <h3 class="text-lg font-semibold text-black dark:text-white">{{ vehicle.brand }} {{ vehicle.vehicle_model }}</h3>
      <p class="text-gray-600 dark:text-gray-300">{{ vehicle.year }}</p>
      <p class="text-gray-600 dark:text-gray-300">{{ vehicle.km }} km</p>
    </div>

    <div class="flex justify-center gap-4 mt-4">
      <button type="button" class="text-primary" ngxTippy="Editar" (click)="openEditModal(vehicle)">
        <icon-pencil></icon-pencil>
      </button>
      <button type="button" class="text-primary" ngxTippy="Eliminar" (click)="onDelete(vehicle)">
        <icon-trash-lines></icon-trash-lines>
      </button>
      <button type="button" class="text-primary" ngxTippy="open-ods" (click)="openOds(vehicle)">
        <icon-list-check></icon-list-check>
      </button>
    </div>
    <div class="flex flex-wrap justify-center gap-3 mt-3 flex-col content-center">
      <button class="btn btn-sm bg-primary border border-white w-full sm:w-1/2 text-center py-2" (click)="goCita(vehicle)">Agendar Cita</button>

      <button class="btn btn-sm bg-primary border border-white btn-outline w-full sm:w-1/2 text-center py-2" (click)="goDocumentation(vehicle)">
        Documentación
      </button>
      <!-- <button class="btn btn-sm bg-primary border border-white" (click)="modal18.open()">Ver pico y placa</button> -->
    </div>
  </div>
</div>

<!-- Modal de Edición -->
<app-modal-vehicle-edit *ngIf="showModal" [selectedVehicle]="selectedVehicle" (close)="closeModal()"> </app-modal-vehicle-edit>

<!-- Modal de ODS -->
<div *ngIf="ModalOds" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-lg z-50" (click)="closeModalOds()">
  <div
    class="bg-white dark:bg-gray-800 w-11/12 md:w-1/2 lg:w-1/2 max-h-[80vh] max-w-[90vw] overflow-auto p-6 rounded-lg shadow-lg relative"
    (click)="$event.stopPropagation()"
  >
    <button class="absolute top-2 right-2 text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white text-xl" (click)="closeModalOds()">✖</button>

    <app-ods [selectedVehicle]="selectedVehicle"></app-ods>
  </div>

  <!-- Modal -->
</div>

<!-- <app-list-vehicle></app-list-vehicle> -->

<!-- tabs -->
<!-- <div #modal18></div> -->

<!-- Trigger -->
<!-- <button type="button" class="btn btn-sm bg-primary border border-white" (click)="modal18.open()">{{ 'VEHICLES.BUTTON' | translate }}</button> -->

<!-- Modal -->
